import React from 'react';

import IconWithBorder from '../icons/IconWithBorder';
import WallarooIcon from '../icons/WallarooIcon';

// TODO - The structure of this component will change drastically when we can support user avatars
export const WallarooAvatar = ({ className = null, fill = 'white', bgColor = 'border-darker' }) => (
  <IconWithBorder
    className={className}
    icon={WallarooIcon}
    fill={fill}
    bgColor={bgColor}
    size={32}
    padding={1}
  />
)

export default WallarooAvatar;
